import {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import WidgetsLoader from '@components/WidgetsLoader';
import {authService} from '@services/auth.service';

/**
 * Resuelve la ruta pos-login (incluye auto-selección de empresa para cuentas
 * ADMIN_EMPRESA_CLIENTE con una sola empresa vinculada).
 */
const PostLoginNavigate = () => {
    const [targetPath, setTargetPath] = useState<string | null>(null);

    useEffect(() => {
        let mounted = true;

        const resolve = async () => {
            try {
                const path = await authService.resolvePostLoginNavigation({
                    user: authService.getUser() ?? undefined,
                    token: authService.getToken() ?? undefined,
                    available_empresas: authService.getAvailableEmpresas()
                });

                if (mounted) {
                    setTargetPath(path);
                }
            } catch {
                if (mounted) {
                    setTargetPath('/login');
                }
            }
        };

        resolve();

        return () => {
            mounted = false;
        };
    }, []);

    if (!targetPath) {
        return <WidgetsLoader />;
    }

    return <Navigate to={targetPath} replace />;
};

export default PostLoginNavigate;
